
















import { Component, Vue } from 'vue-property-decorator';
import LocaleSelect from '@/components/LocaleSelect.vue';
import LoginLayout from '@/components/views/layouts/LoginLayout.vue';
import store from '@/store';
import { loadLocaleForVehiclesTypes } from '@/i18n';
import { LelyUserDefinition } from '@hn-work/frontend-vue-shared';
import { NEW_APP_ALARMS_HOME, newAppUrl } from '@/core/newAppUrl';

@Component({
    components: { LoginLayout, LocaleSelect },
})
export default class Login extends Vue {
    async authenticated(user: LelyUserDefinition, redirectTo?: string): Promise<void> {
        this.$store.commit('setCurrentUser', user);

        // Alarms live in the new (Angular) Alarm Center now, so a plain login
        // hands straight over to it — before syncing this app's data, which the
        // user is about to navigate away from anyway. Only a deep link
        // (`redirect_to`, set by the router guard) still lands in this app.
        if (!redirectTo) {
            window.location.href = newAppUrl(NEW_APP_ALARMS_HOME);

            return;
        }

        this.$store.dispatch('runs/syncRuns').then();
        this.$store.dispatch('tickets/syncOpenTickets').then();
        await this.$store.dispatch('syncMasterData');
        await this.$store.dispatch('initSyncInterval');
        await loadLocaleForVehiclesTypes(store.getters.localeKeys, store.getters.vehicleTypesSet);

        await this.$router.push({ path: redirectTo });
    }
}

